import type { AxiosInstance } from 'axios';
import authService from './auth.service';

/**
 * Creating a product (#277). One super admin names a funds vehicle and creates its product with a
 * step-up code. The product is born NOT operable; the readiness gate decides afterwards.
 *
 *   POST /api/v1/admin/products                    create
 *   GET  /api/v1/admin/products/available-vehicles funds vehicles with no product
 */
export type Market = 'MX' | 'US' | 'CA';
export type FundingRoute = 'private_fund';

export interface AvailableVehicle {
  funds_product_id: string;
  name: string;
  asset_class: string;
  currency_code: string;
  jurisdiction: string;
  /** What funds fixed when it created the vehicle (#383); null when funds did not send it. */
  product_type: string | null;
  exit_path: string | null;
  price_basis: string | null;
}

export interface CreateBody {
  funds_product_id: string;
  supported_markets: Market[];
  funding_route: FundingRoute;
  description: string;
  risk_level: number | null;
  mfa_code: string;
}

export interface CreatedProduct {
  product_id: string;
  is_active: boolean;
}

class AdminProductsService {
  private get api(): AxiosInstance {
    return authService.getApi();
  }

  private readonly base = '/api/v1/admin/products';

  async availableVehicles(): Promise<AvailableVehicle[]> {
    const res = await this.api.get<AvailableVehicle[]>(`${this.base}/available-vehicles`);
    return res.data;
  }

  async create(body: CreateBody): Promise<CreatedProduct> {
    const res = await this.api.post<CreatedProduct>(this.base, body);
    return res.data;
  }
}

export default new AdminProductsService();
